import {
    Site,
    Locale,
} from '@superbet-group/web.types';
import {
    getAdjacentHostname,
    getAdjacentUrl,
    getCurrentSite,
} from '@app/utils/domainHelpers';

import { shellLocalConfig } from '@src/config/shell/localConfig';
import { SiteLanguageConfig } from '@modules/app/siteLanguage/siteLanguageConfig';

export function createGetLocaleRedirectUrl(currentHostname: string, availableSites: Site[]) {
    return function getLocaleRedirectUrl(locale: Locale, targetPath: string): URL {
        const currentSite = getCurrentSite(currentHostname);
        const otherSites = availableSites.filter((site) => {
            return site !== currentSite;
        });

        const setLocaleUrl = `https://${currentHostname}/static/js/setLocale?locale=${locale.toString()}`;
        const nexts = otherSites.map((site) => `&next=${getAdjacentHostname(currentHostname, site)}`).join('');
        const target = getAdjacentUrl(currentHostname, currentSite, `/${locale.toString().toLowerCase()}` + targetPath);

        return new URL(
            [
                setLocaleUrl,
                nexts,
                `&target=${encodeURIComponent(target)}`,
            ].join(''),
        );
    };
}

export const getLocaleRedirectUrl = createGetLocaleRedirectUrl(window.location.hostname, shellLocalConfig.sites);

/**
 * Can happen in public coffee shops. CustomerEnglish sets English,
 * CustomerDutch who understands English logs in and his locale is actually Dutch
 */
export function isLocaleMismatchOnMultiLingualTarget(userLocale: Locale | undefined, appLocale: Locale): boolean {
    if (!userLocale) {
        return false;
    }
    return SiteLanguageConfig.isMultiLingualSite && userLocale !== appLocale;
}
